import { Field } from './Field';
import { IMultiField } from './IMultiField';
import { ComparisonType } from './ComparisonType';
import { ResourceEntityType } from '../../resources/ResourceEntityType';

type ResourceEntity = {
  type: ResourceEntityType,
  value: string
};

export class MultiNamedEntityField extends Field implements IMultiField<ResourceEntity> {
  public values: ResourceEntity[];
  public resourceEntityType: ResourceEntityType;

  constructor(name: string, description: string, values: ResourceEntity[] = null, comparisonType: ComparisonType = null, resourceEntityType: ResourceEntityType = ResourceEntityType.CommercialItem) {
    super(name, description, MultiNamedEntityField.typeName(), comparisonType);
    this.values = values;
    this.resourceEntityType = resourceEntityType;
  }

  public static typeName(): string {
    return "io.indexed.domainmodel.search.advanced.MultiNamedEntityField";
  }
}
